import React from "react";
import Typography from "@mui/material/Typography";

import { SectionPageIntroProps } from "src/library/types/types";
import { TEASER_SITE_ENABLED } from "src/library/constants";

export default function SectionBody(props: SectionPageIntroProps) {
  const { text, style } = props;

  return (
    <Typography
      variant="body1"
      component="p"
      textAlign="justify"
      py={1}
      fontSize={TEASER_SITE_ENABLED ? "1.4rem" : "1.05rem"}
      sx={style}
    >
      {text}
    </Typography>
  );
}
